import { Post } from "../utils/http.js"

export function login(param) {
  return Post(
    "/api/mem/passport/login",
    { param },
    {
      shouldErrorHandler: true
    }
  )
}
export function signUp(param) {
  return Post(
    "/api/mem/passport/register",
    { param },
    {
      shouldErrorHandler: true
    }
  )
}

export function rtaLogout(param) {
  return Post("/api/mem/passport/logout", { param })
}

export function sendSmsVerifyCode(param) {
  return Post("/api/mem/passport/validCode", { param })
}

export function getLoginTerms(param) {
  return Post("https://appapi.rta-os.com/app/user/protocol", {
    param: '{"type":"1"}'
  })
}

export function checkPassword(param) {
  return Post("/api/mem/passport/checkPassword", { param })
}

export function resetPassword(param) {
  return Post("/api/mem/passport/password", { param })
}

export function createPassword(param) {
  return Post("/api/mem/passport/setpwd", { param })
}

export function updateInfo(param) {
  return Post("/api/mem/passport/updateInfo", { param })
}

export function getUserInfo(param) {
  return Post("/api/mem/passport/userInfo", { param })
}

export function getIsMember(param) {
  return Post("/api/mem/passport/queryByPhone", { param })
}
